import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface VerifySkuLoanApplicationsRequest {
  token: string;
  skuIds: string[];
}

const verifySkuLoanApplications = async ({
  token,
  skuIds,
}: VerifySkuLoanApplicationsRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-disbursement/pm-verify-sku-loan-applications`,
      { skuIds },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default verifySkuLoanApplications;
